module.exports = __webpack_public_path__ + "static/media/otherSportEquipment.24c972da.svg";